
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTriangleWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  viewBox: "0 0 20 18",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.581.248a2 2 0 0 1 .789.789l7.617 13.85a2 2 0 0 1-1.752 2.963H2a2 2 0 0 1-1.752-2.964l7.617-13.85a2 2 0 0 1 2.716-.788ZM9.617 12.2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm.024-7.5c-.69 0-1.25.56-1.25 1.25V9.6a1.25 1.25 0 0 0 2.5 0V5.95c0-.69-.56-1.25-1.25-1.25Z",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"18\" viewBox=\"0 0 20 18\" fill=\"none\">\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5813 0.24794C10.9136 0.430716 11.1871 0.704215 11.3699 1.03653L18.9873 14.8865C19.5197 15.8543 19.1666 17.0704 18.1988 17.6027C17.9035 17.7651 17.5719 17.8503 17.2349 17.8503H2C0.89543 17.8503 0 16.9549 0 15.8503C0 15.5133 0.0851587 15.1817 0.247568 14.8865L7.86503 1.03653C8.39734 0.0686932 9.61345 -0.284373 10.5813 0.24794ZM9.61746 12.2006C8.78903 12.2006 8.11746 12.8722 8.11746 13.7006C8.11746 14.529 8.78903 15.2006 9.61746 15.2006C10.4459 15.2006 11.1175 14.529 11.1175 13.7006C11.1175 12.8722 10.4459 12.2006 9.61746 12.2006ZM9.64099 4.70059C8.95063 4.70059 8.39099 5.26023 8.39099 5.95059V9.60028C8.39099 10.2906 8.95063 10.8503 9.64099 10.8503C10.3313 10.8503 10.891 10.2906 10.891 9.60028V5.95059C10.891 5.26023 10.3313 4.70059 9.64099 4.70059Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/triangleWarning.41df5e0998e87da6df631d4c6e63098a.svg"),
        {
          React: SvgTriangleWarning,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      